import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  filterConstants,
  FILTERS_CONSTANTS,
  PAYMENT_CATEGORY,
  PAYMENT_STATUS,
  ACCOUNT_TYPE_GROUPS,
  TierOptions,
  TAG_STATUS,
  TAG_TYPE,
  POST_DATED_PAYMENT_METHODS,
  PRE_DATED_PAYMENT_METHODS,
  BILL_STATUS,
  JOURNAL_ENTRIES_STATUSES,
  ORDER_STATUS,
} from "../Common/constants";
import { Spin } from "antd";
import { findMultipleBrands } from "../Catalog/_redux/brands/brandsCrud";
import { findCategoryById, findMsaCategoryById } from "../Catalog/_redux/categories/categoriesCrud";
import { findMultipleSuppliersbyId } from "../Inventory/_redux/suppliers/suppliersCrud";
import { getPurchaseReceiveById } from "../Inventory/_redux/purchase-order-receive/purchaseOrderReceiveCrud";
import { getPurchaseReturnsById } from "../Inventory/_redux/purchase-returns/purchaseReturnsCrud";
import { findUsers, getSingleUser } from "../User/_redux/users/usersCrud";
import { getCustomerGroupById } from "../Sale/_redux/customer-groups/customerGroupsCrud";
import { findCustomerById } from "../Sale/_redux/orders/ordersCrud";
import { getProductById } from "../Catalog/_redux/products/productsCrud";
import { getChannelsById } from "../Inventory/_redux/stocks/stocksCrud";
import { getSingleTaxClassRequest } from "../User/_redux/tax/requests";
import { getAllAccounts } from "../Accounting/_redux/charts-of-accounts/ChartsOfAccountsCrud";
import { handleApiErrorResponse, PRODUCT_STATUS_OPTIONS } from "./utils";
import { Custom_Status_Name } from "../Report/pages/purchasing-inventory/financial-reporting/payment-received-report/payment-reveived-filter/PaymentReceivedFilter";
import { getVehicleById } from "../DeliveryShipping/logic/requests";

const MSA_FILTER_LABELS = { Y: "Yes", N: "No" };

const ShowSelectedAdvanceFilter = ({ popoverVisible, moduleSearchFilter, module }) => {
  const [filterLoading, setFilterLoading] = useState(true);
  const [filterToDisplayProducts, setFilterToDisplayProducts] = useState({
    brand_name: "",
    cat_name: "",
    msa_category: "",
    pro_name: "",
    channel_name: "",
    tax_name: "",
    user_name: "",
    collected_by: "",
    user_by: "",
    deposit_To_account_ids: "",
  });
  const [filterToDisplayPO, setFilterToDisplayPO] = useState({ sup_name: "", purchase_Receive: "", purchase_return: "" });
  const [filterToDisplayCustomer, setFilterToDisplayCustomer] = useState({ agent_name: "", cust_group: "" });
  const [filterToDisplayReport, setFilterToDisplayReport] = useState({ cust_name: "" });
  const [filterToDisplayVehicle, setFilterToDisplayVehicle] = useState({ assigned_riders: "", vehicleNos: "", vehicle_channel_name: "" });
  const [filterToDisplaySaleOrders, setFilterToDisplaySaleOrders] = useState({ prefer_driver: "" });

  const filterMappings = {
    product_catalog: {
      products: "product_search_filter",
      category: "category_search_filter",
    },
    inventory: {
      purchase_order: "purchase_order_filter",
      purchase_receives: "purchase_receives_filter",
      purchase_returns: "purchase_returns_filter",
      stocks_alert: "stock_alert_filter",
      stocks: "stock_search_filter",
      supplier_payment: "supplier_payment_filter",
      supplier_payment_logs: "supplier_payment_logs_filter",
    },
    sale: {
      customer: "customer_search_filter",
      sale_history: "saleHistory_search_filter",
      fulfilments: "fulfillment_search_filter",
      payment_history: "payments_search_filter",
      payment_logs_history: "payments_logs_search_filter",
      invoice_history: "invoice_history_filter",
      sale_return: "saleReturn_search_filter",
      sale_return_voided: "saleReturnVoided_search_filter",
    },
    accounting: {
      bills: "bills_list_filter",
      expenses: "expense_list_filter",
      departments: "departments_list_filter",
      journal_entries: "journal_entries_list_filter",
      chart_of_accounts: "chart_of_accounts_filter",
    },
    tags: {
      tags: "tags_search_filter",
    },
    reporting: {
      cetegory_velocity: "cetegory_velocity_filter",
      customer_velocity_filter: "customer_category_velocity_filter",
      customer_category_sale: "customer_category_sale_filter",
      sale_summary: "sale_summary_filter",
      brand_velocity: "brand_price_filter",
      customer_brand_velocity: "customer_brand_filter",
      item_detail: "item_detail_filter",
      item_velocity: "item_velocity_filter",
      item_velocity_week_on_week: "ItemVelocityReportWOW_filter",
      customer_product_velocity: "customer_product_velocity_filter",
      customer_performance_report: "customer_performance_report_filter",
      customer_velocity_YOY: "CustomerVelocityReportYOY_filter",
      county_velocity_report: "county_velocity_report_filter",
      customer_velocity_report: "customer_velocity_report_filter",
      sale_rep_category: "sale_rep_category_filter",
      sale_rep_product: "sale_rep_product_filter",
      sale_rep_brand_report: "sale_rep_brand_report_filter",
      lost_sale_report: "lost_sale_report_filter",
      po_history: "po_history_filter",
      po_received: "po_received_filter",
      inven_evaluation: "inven_evaluation_filter",
      inven_spot_check: "inven_spot_check_filter",
      inven_location: "inven_location_filter",
      partially_fulfill: "partially_fulfill_filter",
      on_hold: "on_hold_filter",
      back_order: "back_order_filter",
      account_receive: "account_receive_filter",
      supplier_payable: "supplier_payable_filter",
      payment_receive: "payment_receive_filter",
      payment_log: "payment_log_filter",
      cust_aging: "cust_aging_filter",
      invoice_history: "invoice_history_filter",
      sup_payment_log: "sup_payment_log_filter",
      sales_commission: "sales_commission_filter",
      po_return_history: "purchase_return_history_filter",
      post_dated_payment: "post_dated_payments_report_filter",
      pre_dated_payment: "pre_dated_payments_report_filter",
      non_performance_report: "non_performance_report_filter",
      item_velocity_month_on_month: "ItemVelocityReportMOM_filter",
      california_cigarette_sales: "california_ciggerate_sales_report_filter",
    },
    delivery: {
      vehicle_listing: "vehicle_filter",
      delivery_routes: "route_filter",
      delivery_by_order: "delivery_by_order_search_filter",
    },
    dashboard: {
      aging_invoice: "aging_invoice_filter",
    },
  };
  const isAccountingBillsFilter = module === "accounting" && moduleSearchFilter === "bills";
  const isAccountingExpensesFilter = module === "accounting" && moduleSearchFilter === "expenses";
  const isAccountingDepartmentsFilter = module === "accounting" && moduleSearchFilter === "departments";
  const isAccountingChartOfAccountsFilter = module === "accounting" && moduleSearchFilter === "chart_of_accounts";
  const userBy = module === "sale" && ["sale_history", "fulfilments", "sale_return", "sale_return_voided"].includes(moduleSearchFilter);
  const isSaleReturnFilter = module === "sale" && ["sale_return", "sale_return_voided"].includes(moduleSearchFilter);
  const isAccountingJournalEntriesFilter = module === "accounting" && moduleSearchFilter === "journal_entries";
  const isDashboardAgingFilter = module === "dashboard" && moduleSearchFilter === "aging_invoice";
  const isProductListFilter = module === "product_catalog" && moduleSearchFilter === "products";
  const filterKey = filterMappings[module]?.[moduleSearchFilter];
  const savedSearchFilter = filterKey ? JSON.parse(localStorage.getItem(filterKey)) : null;
  let localSearchFilter = savedSearchFilter;
  if (isAccountingBillsFilter && savedSearchFilter?.advance_filters) {
    const { statuses, ...filters } = savedSearchFilter.advance_filters;
    localSearchFilter = {
      ...savedSearchFilter,
      advance_filters: {
        ...filters,
        bill_status: filters.bill_status || statuses || "",
      },
    };
  }
  if (isAccountingExpensesFilter && savedSearchFilter?.advance_filters) {
    const { statuses, start_date, end_date, ...filters } = savedSearchFilter.advance_filters;
    localSearchFilter = {
      ...savedSearchFilter,
      advance_filters: {
        ...filters,
        expense_status: filters.expense_status || statuses || "",
        expense_start_date: filters.expense_start_date || start_date || "",
        expense_end_date: filters.expense_end_date || end_date || "",
      },
    };
  }
  if (isAccountingJournalEntriesFilter && savedSearchFilter?.advance_filters) {
    const { statuses, start_date, end_date, ...filters } = savedSearchFilter.advance_filters;
    localSearchFilter = {
      ...savedSearchFilter,
      advance_filters: {
        ...filters,
        journal_entry_start_date: filters.journal_entry_start_date || start_date || "",
        journal_entry_end_date: filters.journal_entry_end_date || end_date || "",
        journal_entry_statuses: filters.journal_entry_statuses || statuses || [],
      },
    };
  }
  if (isAccountingDepartmentsFilter && savedSearchFilter?.advance_filters) {
    const { is_active, department_status, ...filters } = savedSearchFilter.advance_filters;
    localSearchFilter = {
      ...savedSearchFilter,
      advance_filters: {
        ...filters,
        department_status: department_status ?? is_active ?? "",
      },
    };
  }

  const fetchProducts = async (productIds) => {
    try {
      const productPromises = productIds.map((id) => getProductById(id));
      const productResponses = await Promise.all(productPromises);
      const productNames = productResponses.map((response) => {
        return response.data.entity?.name || "Unknown product";
      });
      return productNames.join(", ");
    } catch (error) {
      console.error("Error fetching product:", error);
      return "";
    }
  };

  const fetchBrands = async (brandIds) => {
    try {
      const brandPromises = brandIds.map((id) => findMultipleBrands(id));
      const brandResponses = await Promise.all(brandPromises);
      const brandNames = brandResponses.map((response) => {
        return response.data.entities?.map((brand) => brand.name) || "Unknown Brand";
      });
      return brandNames.join(", ");
    } catch (error) {
      console.error("Error fetching brands:", error);
      return "";
    }
  };
  const fetchCategories = async (categoryIds) => {
    try {
      const categoryPromises = categoryIds.map((id) => findCategoryById(id));
      const categoryResponses = await Promise.all(categoryPromises);
      const categoryNames = categoryResponses.map((response) => {
        return response.data.entity?.name || "Unknown Category";
      });
      return categoryNames.join(", ");
    } catch (error) {
      console.error("Error fetching categories:", error);
      return "";
    }
  };
  const fetchMsaCategories = async (categoryIds) => {
    try {
      const categoryPromises = categoryIds.map((id) => findMsaCategoryById(id));
      const categoryResponses = await Promise.all(categoryPromises);
      const categoryNames = categoryResponses.map((response) => {
        return `${response.data.entity?.code} - ${response.data.entity?.name}` || "Unknown Category";
      });
      return categoryNames.join(", ");
    } catch (error) {
      console.error("Error fetching categories:", error);
      return "";
    }
  };
  const fetchCustomer = async (customerIds) => {
    try {
      const customerPromises = customerIds.map((id) => findCustomerById(id));
      const customerResponses = await Promise.all(customerPromises);
      const customerNames = customerResponses.map((response) => {
        return response.data.entity?.business_name || "Unknown customer";
      });
      return customerNames.join(", ");
    } catch (error) {
      console.error("Error fetching customer:", error);
      return "";
    }
  };

  const fetchSuppliers = async (supplierIds) => {
    try {
      const supplierPromises = supplierIds.map((id) => findMultipleSuppliersbyId(id));
      const supplierResponses = await Promise.all(supplierPromises);
      const supplierNames = supplierResponses.map((response) => {
        return response.data.entities?.map((supplier) => supplier.supplier_name) || "Unknown Category";
      });
      return supplierNames.join(", ");
    } catch (error) {
      console.error("Error fetching categories:", error);
      return "";
    }
  };

  const getPurchaseRecieves = async (PurchaseReceiveIds) => {
    try {
      const PurchaseReceivePromises = PurchaseReceiveIds.map((id) => getPurchaseReceiveById(id));
      const PurchaseReceiveResponses = await Promise.all(PurchaseReceivePromises);
      const PurchaseReceiveNames = PurchaseReceiveResponses.map((response) => {
        return response.data.entity?.no || "Unknown Category";
      });
      return PurchaseReceiveNames.join(", ");
    } catch (error) {
      console.error("Error fetching categories:", error);
      return "";
    }
  };

  const getPurchaseReturn = async (PurchaseReturnIds) => {
    try {
      const PurchaseReturnPromises = PurchaseReturnIds.map((id) => getPurchaseReturnsById(id));
      const PurchaseReturnResponses = await Promise.all(PurchaseReturnPromises);
      const PurchaseReturnNames = PurchaseReturnResponses.map((response) => {
        return response.data.entity?.no || "Unknown PurchaseReturn";
      });
      return PurchaseReturnNames.join(", ");
    } catch (error) {
      console.error("Error fetching categories:", error);
      return "";
    }
  };

  const getSaleAgent = async (SaleAgentIds) => {
    try {
      const SaleAgentPromises = SaleAgentIds.map((id) => getSingleUser(id));
      const SaleAgentResponses = await Promise.all(SaleAgentPromises);
      const SaleAgentNames = SaleAgentResponses.map((response) => {
        return response.data.entity?.username || "Unknown SaleAgent";
      });
      return SaleAgentNames.join(", ");
    } catch (error) {
      console.error("Error fetching SaleAgent:", error);
      return "";
    }
  };

  const getVehicles = async (vehicle_ids) => {
    try {
      const VehiclePromises = vehicle_ids.map((id) => getVehicleById(id));
      const VehicleResponses = await Promise.all(VehiclePromises);
      const VehicleNo = VehicleResponses.map((response) => {
        return response.data.entity?.no || "Unknown Vehicle";
      });
      return VehicleNo.join(", ");
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      return "";
    }
  };

  const customerGroup = async (customerGroupIds) => {
    try {
      const customerGroupPromises = customerGroupIds.map((id) => getCustomerGroupById(id));
      const customerGroupResponses = await Promise.all(customerGroupPromises);
      const customerGroupNames = customerGroupResponses.map((response) => {
        return response.data.entity?.name || "Unknown customer Group";
      });
      return customerGroupNames.join(", ");
    } catch (error) {
      console.error("Error fetching categories:", error);
      return "";
    }
  };

  const fetchChannelName = async (channelIds) => {
    try {
      const ids = Array.isArray(channelIds) ? channelIds : [channelIds];
      const channelPromises = ids.map((id) => getChannelsById(id));
      const channelResponses = await Promise.all(channelPromises);
      const channelNames = channelResponses.map((response) => {
        return response.data.entity?.name || "Unknown channel";
      });

      return channelNames.join(", ");
    } catch (error) {
      console.error("Error fetching channel:", error);
      return "";
    }
  };
  const fetchTaxClass = async (taxIds) => {
    try {
      const taxPromises = taxIds.map((id) => getSingleTaxClassRequest(id));
      const taxResponses = await Promise.all(taxPromises);
      const taxNames = taxResponses.map((response) => {
        return response.data.entity?.name || "Unknown tax";
      });
      return taxNames.join(", ");
    } catch (error) {
      console.error("Error fetching categories:", error);
      return "";
    }
  };
  const findUser = async (userIds, showusername = true) => {
    try {
      const userPromises = userIds.map((id) => findUsers(id));
      const userResponses = await Promise.all(userPromises);
      const userNames = userResponses.map((response, index) => {
        const user = response.data.entities.find((user) => user.id === userIds[index]);
        return user ? (showusername ? user.username : user.first_name + " " + user.last_name) : "Unknown user";
      });
      return userNames.join(", ");
    } catch (error) {
      console.error("Error fetching users:", error);
      return "";
    }
  };

  const [accountsList, setAccountsList] = useState([]);

  const fetchAllAccounts = async (AccountIds) => {
    const params = {
      type_ids: ACCOUNT_TYPE_GROUPS.ALL_ACCOUNTS,
      pageSize: -1,
    };
    try {
      const response = await getAllAccounts(params);
      const allAccounts = response.data.entities || [];
      const matchedAccount = allAccounts.filter((account) => AccountIds.includes(account.id));
      const depositToAccountIds = matchedAccount.map((account) => account.name || "Unknown");

      return depositToAccountIds.join(", ");
    } catch (err) {
      handleApiErrorResponse(err);
    }
  };

  const createdByIdsKey = JSON.stringify(localSearchFilter?.advance_filters?.created_by_ids || []);

  useEffect(() => {
    if (!popoverVisible) {
      // Trigger only when filter modal is closed
      const {
        brand_ids = [],
        categories = [],
        category_id = [],
        category_ids = [],
        supplier_ids = [],
        customer_ids = [],
        suppliers = [],
        purchase_receives_ids = [],
        purchase_return_ids = [],
        sale_agent_ids = [],
        sale_rep_ids = [],
        sale_agents = [],
        customer_group_ids = [],
        product_ids = [],
        channel_ids = 1,
        tax_classes = [],
        created_by_ids = [],
        collected_by_ids = [],
        user_ids = [],
        deposit_to_account_ids = [],
        assigned_rider_ids = [],
        msa_category_ids = [],
        vehicle_ids = [],
        prefer_driver = [],
        vehicle_channel_ids = [],
      } = localSearchFilter?.advance_filters || {};

      const brandIds = brand_ids;
      const customerIds = Array.isArray(customer_ids) ? customer_ids : [customer_ids];
      const categoryIds = [...categories, ...category_id, ...category_ids];
      const msaCategoryIds = [...msa_category_ids];
      const supplierIds = supplier_ids.length ? supplier_ids : suppliers.map((supplier) => supplier.value);
      const purchaseReceiveIds = purchase_receives_ids;
      const purchaseReturnIds = purchase_return_ids;
      const saleAgentIds = [...sale_agent_ids, ...sale_agents, ...sale_rep_ids];
      const customerGroupIds = customer_group_ids;
      const productIds = product_ids;
      const channelIds = channel_ids;
      const taxIds = tax_classes;
      const userIds = created_by_ids;
      const collectedByIds = collected_by_ids;
      const userByIds = user_ids;
      const depositToAccountIds = deposit_to_account_ids;
      const assignedRiderIds = Array.isArray(assigned_rider_ids) ? assigned_rider_ids : [assigned_rider_ids];
      const vehicleIds = Array.isArray(vehicle_ids) ? vehicle_ids : [];
      const preferDriverIds = Array.isArray(prefer_driver) ? prefer_driver : [];
      const vehicleChannelIds = Array.isArray(vehicle_channel_ids) ? vehicle_channel_ids : [];

      const fetchData = async () => {
        try {
          setFilterLoading(true);

          const [
            brandName,
            catName,
            msaCatName,
            custName,
            supName,
            purchaseReceive,
            purchaseReturn,
            saleAgent,
            custGroup,
            productName,
            chnelName,
            taxName,
            userName,
            collectedBy,
            userBy,
            depositToAccounts,
            assignedRiders,
            vehicleNos,
            preferDrivers,
            vehicleChannels,
          ] = await Promise.all([
            fetchBrands(brandIds),
            fetchCategories(categoryIds),
            fetchMsaCategories(msaCategoryIds),
            fetchCustomer(customerIds),
            fetchSuppliers(supplierIds),
            getPurchaseRecieves(purchaseReceiveIds),
            getPurchaseReturn(purchaseReturnIds),
            getSaleAgent(saleAgentIds),
            customerGroup(customerGroupIds),
            fetchProducts(productIds),
            fetchChannelName(channelIds),
            fetchTaxClass(taxIds),
            findUser(userIds, false),
            findUser(collectedByIds),
            findUser(userByIds),
            fetchAllAccounts(depositToAccountIds),
            findUser(assignedRiderIds, false),
            getVehicles(vehicleIds),
            findUser(preferDriverIds, false),
            fetchChannelName(vehicleChannelIds),
          ]);

          setFilterToDisplayProducts({
            brand_name: brandName,
            cat_name: catName,
            msa_category: msaCatName,
            sup_name: supName,
            pro_name: productName,
            channel_name: chnelName,
            tax_name: taxName,
            user_name: userName,
            collected_by: collectedBy,
            user_by: userBy,
            deposit_To_account_ids: depositToAccounts,
          });
          setFilterToDisplayPO({
            sup_name: supName,
            purchase_Receive: purchaseReceive,
            purchase_return: purchaseReturn,
          });

          setFilterToDisplayReport({
            cust_name: custName,
          });

          setFilterToDisplayCustomer({
            agent_name: saleAgent,
            cust_group: custGroup,
          });
          setFilterToDisplayVehicle((prev) => ({ ...prev, assigned_riders: assignedRiders, vehicleNos, vehicle_channel_name: vehicleChannels }));
          setFilterToDisplaySaleOrders((prev) => ({ ...prev, prefer_driver: preferDrivers }));
        } catch (err) {
          console.error("Error fetching filters:", err);
        } finally {
          setFilterLoading(false);
        }
      };
      fetchData();
    }
  }, [popoverVisible, createdByIdsKey]);

  const categoryTypeOptions = {
    all: "All Categories",
    parent: "Parent Categories",
    child: "Child Categories",
  };
  const msaCategoryOptions = {
    all: "All",
    yes: "MSA Categories",
    no: "Non-MSA Categories",
  };
  const ecomOptions = {
    all: "All",
    enabled: "Enabled",
    disabled: "Disabled",
  };
  const sortAlpha = {
    1: "ID",
    2: "Alphabetically",
  };
  const isCategoryFilter = module === "product_catalog" && moduleSearchFilter === "category";
  const categoryAdvanceFilters = localSearchFilter?.advance_filters || {};
  const categoryMsaValue =
    categoryAdvanceFilters.msaCategoryValue ||
    (["4", 4].includes(categoryAdvanceFilters.categorySelectvalue) ? "yes" : ["5", 5].includes(categoryAdvanceFilters.categorySelectvalue) ? "no" : "all");
  const categoryEcomValue =
    categoryAdvanceFilters.ecomValue ||
    (["2", 2].includes(categoryAdvanceFilters.categorySelectvalue)
      ? "enabled"
      : ["3", 3].includes(categoryAdvanceFilters.categorySelectvalue)
        ? "disabled"
        : "all");

  const saleDraftFilter = JSON.parse(localStorage.getItem("sale_draft_filter")) || {};
  const INVOICE_STATUS_MAP = {
    "": "All",
    9: "Draft Orders",
  };

  const getTierLabel = (tierIds = []) => {
    if (!Array.isArray(tierIds)) return "None";
    return TierOptions.filter((opt) => tierIds.includes(opt.value))
      .map((opt) => opt.label)
      .join(", ");
  };

  const formatFilterValue = (value) => {
    if (Array.isArray(value)) {
      return value
        .map((item) => formatFilterValue(item))
        .filter(Boolean)
        .join(", ");
    }

    if (value && typeof value === "object") {
      const optionValue = value.label ?? value.name ?? value.value ?? value.key;
      return optionValue == null ? "" : String(optionValue);
    }

    return value;
  };
  const formatDateRange = (startDate, endDate) => {
    if (startDate && endDate) return `${startDate} to ${endDate}`;
    return startDate || endDate || "";
  };

  const formatWeekNoYear = (value) => {
    if (!value) return "";
    const weekDate = moment(value);
    return weekDate.isValid() ? weekDate.format("wo-YYYY") : "";
  };

  const isInventoryPurchaseReceiveFilter = module === "inventory" && moduleSearchFilter === "purchase_receives";
  const isInventoryPurchaseReturnFilter = module === "inventory" && moduleSearchFilter === "purchase_returns";
  const isInventoryPurchaseReceiveOrReturnFilter = isInventoryPurchaseReceiveFilter || isInventoryPurchaseReturnFilter;
  const isProductCatalogFilter = module === "product_catalog" && moduleSearchFilter === "products";
  // Stocks always has Product Status and Channel applied, the same way product_catalog/products
  // always has its own defaults applied -- both need the row below regardless of
  // show_advance_filters. That flag only turns on the moment the user actually opens the
  // Advance Filters popover and clicks Apply/Clear (see StocksFilter.js's applyFilter); a
  // returning user's stock_search_filter in localStorage predates that ever happening, and the
  // one-time login seed that sets it (Login.js's setDefaultChannelInStore) only runs the very
  // first time a browser has no stock_search_filter at all, so it never fires for them either.
  const isInventoryStocksFilter = module === "inventory" && moduleSearchFilter === "stocks";
  const productStatuses = Array.isArray(localSearchFilter?.advance_filters?.statuses)
    ? localSearchFilter.advance_filters.statuses
    : String(localSearchFilter?.advance_filters?.statuses || "1")
        .split(",")
        .filter(Boolean);
  const productStatusNames = productStatuses
    .map((status) => ({ 1: "Active", 2: "Inactive", 3: "Discontinued" })[Number(status)])
    .filter(Boolean)
    .join(", ");
  const productFilters = localSearchFilter?.advance_filters || {};
  const productViewName = productFilters.is_archived
    ? "Show Archived Products"
    : productFilters.show_default
      ? "Show All Variants"
      : productFilters.promotion_status
        ? "Show Active Promotion Products"
        : "";
  const productCollectionName =
    {
      is_online: "Online",
      is_new_arrival: "New Arrivals",
      is_featured: "Featured",
      is_hot_seller: "Hot Sellers",
    }[productFilters.collection || productFilters.online_featured] || "";
  const productMediaName =
    {
      1: "Product with Image",
      2: "Product without Image",
    }[productFilters.filter_by_image] || "";
  const billsFilters = localSearchFilter?.advance_filters || {};
  const expenseFilters = localSearchFilter?.advance_filters || {};
  const departmentFilters = localSearchFilter?.advance_filters || {};
  const journalEntriesFilters = localSearchFilter?.advance_filters || {};
  const chartOfAccountsFilters = localSearchFilter?.advance_filters || {};
  const agingInvoiceFilters = localSearchFilter?.advance_filters || {};
  const billStatusName = Object.values(BILL_STATUS).find((status) => String(status.value) === String(billsFilters.bill_status))?.name || "";
  const expenseStatusName = { 1: "Active", 2: "Void" }[expenseFilters.expense_status] || "";
  const departmentStatusName =
    {
      true: "Active",
      false: "Inactive",
      1: "Active",
      0: "Inactive",
    }[departmentFilters.department_status] || "";
  const chartOfAccountsStatusName =
    {
      true: "Active",
      false: "Inactive",
    }[chartOfAccountsFilters.is_active] || "";
  const journalEntryStatuses = journalEntriesFilters.journal_entry_statuses || [];
  const journalEntriesStatusNames = (Array.isArray(journalEntryStatuses) ? journalEntryStatuses : [journalEntryStatuses])
    .filter(Boolean)
    .map((status) => JOURNAL_ENTRIES_STATUSES[Number(status)]?.label)
    .filter(Boolean)
    .join(", ");
  const saleReturnStatusNames = (
    Array.isArray(localSearchFilter?.advance_filters?.statuses) ? localSearchFilter.advance_filters.statuses : [localSearchFilter?.advance_filters?.statuses]
  )
    .filter(Boolean)
    .map((status) => Object.values(ORDER_STATUS).find((orderStatus) => String(orderStatus.value) === String(status))?.type2)
    .filter(Boolean)
    .join(", ");

  const stockProductStatus = localSearchFilter?.advance_filters?.product_status;
  const stockProductStatusNames = (
    Array.isArray(stockProductStatus)
      ? stockProductStatus
      : stockProductStatus !== undefined && stockProductStatus !== null && stockProductStatus !== ""
        ? [stockProductStatus]
        : []
  )
    .map((val) => {
      const option = PRODUCT_STATUS_OPTIONS?.find((opt) => String(opt.value) === String(val));
      return option ? option.label : "";
    })
    .filter(Boolean)
    .join(", ");

  const filterApplied = [
    {
      label: "Months",
      value:
        moduleSearchFilter === "item_velocity_month_on_month" &&
        localSearchFilter?.advance_filters?.month_start &&
        localSearchFilter?.advance_filters?.month_end &&
        `${moment(localSearchFilter?.advance_filters?.month_start).format("YYYY-MM")} to ${moment(localSearchFilter?.advance_filters?.month_end).format("YYYY-MM")}`,
    },
    {
      label: "Month",
      value:
        moduleSearchFilter === "california_cigarette_sales" &&
        localSearchFilter?.advance_filters?.month &&
        localSearchFilter?.advance_filters?.year &&
        moment(`${localSearchFilter.advance_filters.year}-${localSearchFilter.advance_filters.month}`, "YYYY-MM").format("MMM YYYY"),
    },
    { label: "Suppliers", value: filterToDisplayPO?.sup_name },
    { label: "Products", value: filterToDisplayProducts?.pro_name },
    { label: "Categories", value: filterToDisplayProducts?.cat_name },
    { label: "Brands", value: filterToDisplayProducts?.brand_name },
    // vg_ids are saved as { value, label }, so the names are shown without an extra request
    isProductListFilter && { label: "Variant Groups", value: formatFilterValue(localSearchFilter?.advance_filters?.vg_ids || []) },
    isAccountingBillsFilter && { label: "Search", value: billsFilters.searchText },
    isAccountingBillsFilter && { label: "Bill Date", value: formatDateRange(billsFilters.start_bill_date, billsFilters.end_bill_date) },
    isAccountingBillsFilter && { label: "Due Date", value: formatDateRange(billsFilters.start_due_date, billsFilters.end_due_date) },
    isAccountingBillsFilter && { label: "Reference No.", value: billsFilters.ref_no },
    isAccountingBillsFilter && { label: "Vendor", value: billsFilters.vendor_names },
    isAccountingBillsFilter && { label: "Min. Amount", value: Number(billsFilters.min_amount) > 0 ? billsFilters.min_amount : "" },
    isAccountingBillsFilter && { label: "Max. Amount", value: billsFilters.max_amount },
    isAccountingBillsFilter && { label: "Statuses", value: billStatusName },
    isAccountingDepartmentsFilter && { label: "Search", value: departmentFilters.search_key },
    isAccountingDepartmentsFilter && { label: "Parent Department", value: departmentFilters.parent_name },
    isAccountingDepartmentsFilter && { label: "Status", value: departmentStatusName },
    isAccountingChartOfAccountsFilter && { label: "Search", value: chartOfAccountsFilters.searchText },
    isAccountingChartOfAccountsFilter && { label: "Account Type", value: chartOfAccountsFilters.account_type_names },
    isAccountingChartOfAccountsFilter && { label: "Status", value: chartOfAccountsStatusName },
    isAccountingChartOfAccountsFilter && { label: "Account Code", value: chartOfAccountsFilters.code },
    isAccountingJournalEntriesFilter && {
      label: "Posting Date",
      value: formatDateRange(journalEntriesFilters.journal_entry_start_date, journalEntriesFilters.journal_entry_end_date),
    },
    isAccountingJournalEntriesFilter && { label: "Statuses", value: journalEntriesStatusNames },
    isAccountingExpensesFilter && { label: "Search", value: expenseFilters.searchText },
    isAccountingExpensesFilter && { label: "Expense Date", value: formatDateRange(expenseFilters.expense_start_date, expenseFilters.expense_end_date) },
    isAccountingExpensesFilter && { label: "Reference No.", value: expenseFilters.ref_no },
    isAccountingExpensesFilter && { label: "Vendor", value: expenseFilters.vendor_names },
    isAccountingExpensesFilter && { label: "Payment Account", value: expenseFilters.payment_account_names },
    isAccountingExpensesFilter && { label: "Min. Amount", value: Number(expenseFilters.min_amount) > 0 ? expenseFilters.min_amount : "" },
    isAccountingExpensesFilter && { label: "Max. Amount", value: expenseFilters.max_amount },
    isAccountingExpensesFilter && { label: "Statuses", value: expenseStatusName },
    isDashboardAgingFilter && {
      label: "Invoice Date",
      value: formatDateRange(agingInvoiceFilters.start_order_date, agingInvoiceFilters.end_order_date),
    },
    isDashboardAgingFilter && {
      label: "Due Date",
      value: formatDateRange(agingInvoiceFilters.start_due_date, agingInvoiceFilters.end_due_date),
    },
    { label: "Order No. ", value: localSearchFilter?.advance_filters?.no },
    { label: "Supplier Invoice", value: localSearchFilter?.advance_filters?.supplier_invoice },
    saleDraftFilter?.set_draft_filter == 2 && {
      label: "Invoice Status",
      value: INVOICE_STATUS_MAP[localSearchFilter?.advance_filters?.invoice_status_previous],
    },
    {
      label: "Channel",
      value: localSearchFilter?.advance_filters?.channel_ids && `${filterToDisplayProducts?.channel_name}`,
    },
    {
      label: "Product Status",
      value: stockProductStatusNames,
    },
    // Products (/catalog/products): these were computed above but never listed, so the row stayed
    // empty even though Status defaults to Active. productStatusNames falls back to Active when
    // nothing is saved yet, and is empty when a Product View clears the status filter.
    isProductCatalogFilter && { label: "Status", value: productStatusNames },
    isProductCatalogFilter && { label: "Product View", value: productViewName },
    isProductCatalogFilter && { label: "Collection", value: productCollectionName },
    isProductCatalogFilter && { label: "Product Media", value: productMediaName },
    { label: "Tax Class", value: filterToDisplayProducts?.tax_name },

    userBy ? { label: "User", value: filterToDisplayProducts?.user_name } : { label: "Created by", value: filterToDisplayProducts?.user_name },
    { label: "Collected By", value: filterToDisplayProducts?.collected_by },
    { label: "User", value: filterToDisplayProducts?.user_by },
    { label: "Prefer Driver", value: filterToDisplaySaleOrders?.prefer_driver },
    {
      label: "Order Date",
      value:
        localSearchFilter?.advance_filters?.order_date_start &&
        `${localSearchFilter?.advance_filters?.order_date_start} to ${localSearchFilter?.advance_filters?.order_date_end}`,
    },
    {
      label: "Start Date",
      value:
        localSearchFilter?.advance_filters?.startDate &&
        `${localSearchFilter?.advance_filters?.startDate.split("T")[0]} to ${localSearchFilter?.advance_filters?.endDate.split("T")[0]}`,
    },
    {
      label: "Weeks",
      value:
        moduleSearchFilter === "item_velocity_week_on_week" &&
        localSearchFilter?.advance_filters?.week1_start &&
        localSearchFilter?.advance_filters?.week2_start &&
        `${formatWeekNoYear(localSearchFilter?.advance_filters?.week1_start)} to ${formatWeekNoYear(localSearchFilter?.advance_filters?.week2_start)}`,
    },
    {
      label: "Years",
      value: localSearchFilter?.advance_filters?.years && `${localSearchFilter?.advance_filters?.years}`,
    },
    {
      label: "Date",
      value: localSearchFilter?.advance_filters?.date && localSearchFilter?.advance_filters?.date.split("T")[0],
    },

    {
      label: "Start Date",
      value:
        localSearchFilter?.advance_filters?.start_date &&
        `${localSearchFilter?.advance_filters?.start_date.split("T")[0]} to ${localSearchFilter?.advance_filters?.end_date.split("T")[0]}`,
    },
    {
      label: "Expiry Date",
      value:
        localSearchFilter?.advance_filters?.expiry_start_date &&
        `${localSearchFilter?.advance_filters?.expiry_start_date.split("T")[0]} to ${localSearchFilter?.advance_filters?.expiry_end_date.split("T")[0]}`,
    },
    {
      label: "Pickup/Delivery Start Date",
      value:
        localSearchFilter?.advance_filters?.pickupDeliveryDateStart &&
        `${localSearchFilter?.advance_filters?.pickupDeliveryDateStart.split("T")[0]} to ${localSearchFilter?.advance_filters?.pickupDeliveryDateEnd.split("T")[0]}`,
    },
    {
      label: "Delivery Date",
      value:
        localSearchFilter?.advance_filters?.delivery_date_start &&
        `${localSearchFilter?.advance_filters?.delivery_date_start} to ${localSearchFilter?.advance_filters?.delivery_date_end}`,
    },
    { label: "Purchase Receive", value: filterToDisplayPO?.purchase_Receive },
    isInventoryPurchaseReceiveFilter && {
      label: "Purchase Receive No.",
      value: formatFilterValue(localSearchFilter?.advance_filters?.purchase_receive_no),
    },
    isInventoryPurchaseReceiveOrReturnFilter && {
      label: "Purchase Order No.",
      value: formatFilterValue(localSearchFilter?.advance_filters?.purchase_order_no),
    },
    isInventoryPurchaseReceiveFilter && {
      label: "Receiving Date",
      value: localSearchFilter?.advance_filters?.receiving_date && String(localSearchFilter?.advance_filters?.receiving_date).split("T")[0],
    },
    { label: "Purchase Return", value: filterToDisplayPO?.purchase_return },
    isInventoryPurchaseReturnFilter && {
      label: "Purchase Return No.",
      value: formatFilterValue(localSearchFilter?.advance_filters?.purchase_return_no),
    },
    isInventoryPurchaseReturnFilter && {
      label: "Return Date",
      value: localSearchFilter?.advance_filters?.return_date && String(localSearchFilter?.advance_filters?.return_date).split("T")[0],
    },
    moduleSearchFilter !== "stocks"
      ? {
          label: "Channel",
          value: localSearchFilter?.channelForBulkEdit?.map((channel) => channel.name).join(", "),
        }
      : {},

    { label: "Customer", value: filterToDisplayReport?.cust_name },
    { label: "Zone", value: localSearchFilter?.advance_filters?.search_zone },
    { label: "Min Qty", value: localSearchFilter?.advance_filters?.min_qty },
    { label: "Back Order Qty", value: localSearchFilter?.advance_filters?.back_order_qty },
    { label: "Aisle", value: localSearchFilter?.advance_filters?.search_aisle },
    { label: "Bin", value: localSearchFilter?.advance_filters?.search_Bin },
    { label: "Country", value: localSearchFilter?.advance_filters?.country },
    { label: "State", value: localSearchFilter?.advance_filters?.state },
    { label: "City", value: localSearchFilter?.advance_filters?.city },
    { label: "County", value: localSearchFilter?.advance_filters?.county },
    { label: "MSA", value: MSA_FILTER_LABELS[localSearchFilter?.advance_filters?.msa] },
      { label: "Tier", value: TierOptions.find((option) => option.value === localSearchFilter?.advance_filters?.tier)?.label },
      { label: "Supplier Invoice No.", value: localSearchFilter?.advance_filters?.supplier_invoice_no },
    { label: "Sale Order No.", value: localSearchFilter?.advance_filters?.sale_order_num },
    { label: "On Account Balance", value: localSearchFilter?.advance_filters?.on_account_min },
    {
      label: "Tags",
      value: TAG_TYPE[localSearchFilter?.advance_filters?.tag_type],
    },
    {
      label: "Status",
      value: TAG_STATUS[localSearchFilter?.advance_filters?.tag_status],
    },
    {
      label: "Payments",
      value:
        localSearchFilter?.advance_filters?.payments?.length > 0
          ? localSearchFilter.advance_filters.payments.map((payment) => payment?.label).join(", ")
          : null,
    },
    { label: "Orders", value: localSearchFilter?.advance_filters?.orders?.map((order) => order?.label).join(", ") },
    // Products keep statuses as plain ids (shown above as "Status"), so they have no labels here
    !isProductCatalogFilter && {
      label: "Statuses",
      value: localSearchFilter?.advance_filters?.statuses?.map?.((statuse) => statuse?.label).filter(Boolean).join(", "),
    },
    { label: "Statuses", value: localSearchFilter?.advance_filters?.order_status?.map((statuse) => statuse?.label).join(", ") },
    { label: "Statuses", value: localSearchFilter?.advance_filters?.order_statuses?.map((statuse) => statuse?.label).join(", ") },
    { label: "Order Type", value: localSearchFilter?.advance_filters?.order_type?.map((statuse) => statuse?.label).join(", ") },
    { label: "Order Type", value: localSearchFilter?.advance_filters?.order_types?.map((statuse) => statuse?.label).join(", ") },
    { label: "Shipping Type", value: localSearchFilter?.advance_filters?.shipping_type?.map((statuse) => statuse?.label).join(", ") },
    { label: "Customer", value: localSearchFilter?.advance_filters?.customer?.business_name },
    { label: "Customer", value: localSearchFilter?.advance_filters?.business_name },
    { label: "Invoice Statuses", value: localSearchFilter?.advance_filters?.invoice_statuses?.map((status) => status?.label).join(", ") },
    { label: "Vehicles", value: localSearchFilter?.advance_filters?.vehicles?.map((vehicle) => vehicle?.label).join(", ") },

      moduleSearchFilter === "payment_logs_history" && localSearchFilter?.advance_filters?.status
        ? {
        label: "Payment Status",
        value: typeof localSearchFilter?.advance_filters?.status === "string"
          ? localSearchFilter?.advance_filters?.status
              .split(",") // Split the comma-separated string into an array
              .map((statusId) => {
                const status = Object.values(PAYMENT_STATUS).find(item => item.value === statusId.trim());
                return status ? status.name : "Unknown";  // Fallback to "Unknown" if no match is found
              })
              .join(", ")  // Join the array back into a comma-separated string
          : localSearchFilter?.advance_filters?.status
              .map((statusId) => {
                const status = Object.values(PAYMENT_STATUS).find(item => item.value === statusId);
                return status ? status.name : "Unknown";  // Fallback to "Unknown" if no match is found
              })
              .join(", ")  // If it's an array, join as before
          }
        : {},
      ([filterConstants.PAYMENT_LOG, filterConstants.PAYMENT_RECEIVE].includes(moduleSearchFilter) &&
      localSearchFilter?.advance_filters?.payment_status?.length
        ? {
            label: "Payment Status",
            value: localSearchFilter.advance_filters.payment_status
              .map((statusId) => {
                const status = Object.values(PAYMENT_STATUS).find((item) => String(item.value) === String(statusId));
                if (!status) return null;
                return Custom_Status_Name[status.value] || status.name;
              })
              .filter(Boolean)
              .join(", "),
          }
        : {}),
      {
        label: "Payment Type",
        value: localSearchFilter?.advance_filters?.payment_methods
          ?.map((statusId) => {
            // Pre Dated Payments adds cash/card/wire transfer/money order on top of the
            // post dated cheque + ACH options, so fall through to the wider list.
            const status =
              POST_DATED_PAYMENT_METHODS.find((item) => item.value === statusId) ||
              PRE_DATED_PAYMENT_METHODS.find((item) => item.value === statusId);
            return status ? status.label : "Unknown"; // Fallback to "Unknown" if no match is found
          })
          .join(", "),
      },
      {
        label: "Payment Received Date Range",
        value:
          localSearchFilter?.advance_filters?.received_start_date &&
          `${localSearchFilter?.advance_filters?.received_start_date} to ${localSearchFilter?.advance_filters?.received_end_date}`,
      },
      {
        label: "Applied Payment Date Range",
        value:
          localSearchFilter?.advance_filters?.applied_start_date &&
          `${localSearchFilter?.advance_filters?.applied_start_date} to ${localSearchFilter?.advance_filters?.applied_end_date}`,
      },
      { label: "Order No.", value: localSearchFilter?.advance_filters?.order?.no },

    moduleSearchFilter === "payment_logs_history"
      ? {
          label: "Order No.",
          value: localSearchFilter?.advance_filters?.sale_order_no?.key || "",
        }
      : {
          label: "Order No.",
          value: localSearchFilter?.advance_filters?.sale_order_no || "",
        },

    // { label: "Order No.", value: localSearchFilter?.advance_filters?.sale_order_no },
    // { label: filterKey == "payments_search_filter" ? "Transaction Id" : "Order No.3", value: localSearchFilter?.advance_filters?.payment_ids },
    { label: "Reference No.", value: localSearchFilter?.advance_filters?.reference_no },
    { label: "Sale Agent", value: filterToDisplayCustomer?.agent_name },
    { label: "Customer Group", value: filterToDisplayCustomer?.cust_group },
    {
      label: "Tier",
      value: getTierLabel(localSearchFilter?.advance_filters?.tier_id),
    },
    { label: "Class Of Trades", value: localSearchFilter?.advance_filters?.class_of_trades },
    { label: "Min.", value: localSearchFilter?.advance_filters?.min_payment },
    { label: "Max.", value: localSearchFilter?.advance_filters?.max_payment },
    { label: "Reference Number", value: localSearchFilter?.advance_filters?.reference_number },
    { label: "Order Number", value: localSearchFilter?.advance_filters?.purchase_order_no },
    { label: "Payment ID", value: localSearchFilter?.advance_filters?.payment_ids },
    { label: "Zip Code", value: localSearchFilter?.advance_filters?.zip_codes },
    { label: "Customer Name", value: localSearchFilter?.advance_filters?.customer_name },
    { label: "License Plate No.", value: localSearchFilter?.advance_filters?.license_plate_number },
    filterToDisplayVehicle?.assigned_riders ? { label: "Assign Riders", value: filterToDisplayVehicle?.assigned_riders } : null,
    filterToDisplayVehicle?.vehicleNos ? { label: "Vehicles", value: filterToDisplayVehicle?.vehicleNos } : null,
    filterToDisplayVehicle?.vehicle_channel_name ? { label: "Channels", value: filterToDisplayVehicle?.vehicle_channel_name } : null,
    isCategoryFilter
      ? {
          label: "Sort By Category",
          value: categoryTypeOptions[categoryAdvanceFilters.categoryTypeValue || "all"],
        }
      : null,
    isCategoryFilter
      ? {
          label: "Sort By",
          value: sortAlpha[categoryAdvanceFilters.sortSelectedValue || "1"],
        }
      : null,
    isCategoryFilter
      ? {
          label: "MSA Category",
          value: msaCategoryOptions[categoryMsaValue],
        }
      : null,
    isCategoryFilter
      ? {
          label: "Ecom",
          value: ecomOptions[categoryEcomValue],
        }
      : null,
    { label: "MSA Category", value: filterToDisplayProducts?.msa_category },
    { label: "Deposit To", value: filterToDisplayProducts?.deposit_To_account_ids },
  ].filter(Boolean);
  return (
    <Spin spinning={filterLoading}>
      {(localSearchFilter?.show_advance_filters || isProductCatalogFilter || isInventoryStocksFilter) && (
        <div className="filter-applied" style={{ display: "flex", flexFlow: "wrap" }}>
          {filterApplied.filter(({ value }) => value).length ? (
            <>
              <div className="filter-applied">Filters Applied:</div>
              {filterApplied.map(({ label, value }) =>
                value ? (
                  <div key={label} className="filter-applied">
                    <div className="filter-applied-heading">{label}:</div>
                    {value}
                  </div>
                ) : null
              )}
            </>
          ) : null}
          {[
            isProductCatalogFilter
              ? {}
              : {
                  filterKey: "online_featured",
                  constantKey: "ONLINE_PRODUCTS",
                  defaultName: "Show All Products",
                  label: "Products",
                },
            {
              filterKey: "is_tax_applicable",
              constantKey: "TAXABLE_PRODUCTS",
              defaultName: "Taxable Products",
              label: "Products",
            },
            {
              filterKey: "tax_applied",
              constantKey: "TAX_APPLIED",
              defaultName: "TAX_APPLIED",
              label: "Tax Applied",
            },
            {
              filterKey: "is_exempt_from_tax",
              constantKey: "IS_EXEMPTED_FROM_TAX",
              defaultName: "Customers Exempted from Tax",
              label: "Customers",
            },
            isProductCatalogFilter
              ? {}
              : {
                  filterKey: "filter_by_image",
                  constantKey: "FILTER_PRODUCT_IMAGE",
                  defaultName: "",
                  label: "Products",
                },
            // {
            //     constantKey: "MSA_PRODUCTS",
            //     defaultName: "All Products",
            //     label: "Products"
            // },
            moduleSearchFilter !== "products"
              ? {
                  filterKey: "statuses",
                  constantKey: "STATUSES",
                  defaultName: "",
                  label: "Statuses",
                }
              : {},
            {
              filterKey: "quantity_low_high",
              constantKey: "STOCK_ALERT",
              defaultName: "",
              label: "Stock",
            },
            {
              filterKey: "damaged_product",
              constantKey: "DAMAGE_PRODUCT",
              defaultName: "",
              label: "Products",
            },
            {
              filterKey: "out_of_stock",
              constantKey: "OUT_OF_STOCK_PRODUCT",
              defaultName: "",
              label: "Products",
            },
            {
              filterKey: "is_active",
              constantKey: "SHOW_CUSTOMER",
              defaultName: "",
              label: "Customers",
            },
            ...(localSearchFilter?.advance_filters?.allow_ecom
              ? [
                  {
                    filterKey: "allow_ecom",
                    constantKey: "SHOW_CUSTOMER",
                    defaultName: "",
                    label: "Customer",
                  },
                ]
              : []),
            {
              filterKey: "customer_type",
              constantKey: "CUSTOMER_TYPE",
              defaultName: "",
              label: "Customer Type",
            },
            ...(localSearchFilter?.advance_filters?.expired_license
              ? [
                  {
                    filterKey: "expired_license",
                    constantKey: "SHOW_CUSTOMER",
                    defaultName: "",
                    label: "License",
                  },
                ]
              : []),
            {
              filterKey: "shippingType",
              constantKey: "SHIPPING",
              defaultName: "",
              label: "Shipping Type",
            },
            {
              filterKey: "guest",
              constantKey: "GUEST",
              defaultName: "",
              label: "Customer",
            },
            {
              filterKey: "category",
              constantKey: "PAYMENT_CATEGORY",
              defaultName: "",
              label: "Payment Category",
            },
            {
              filterKey: "payment_categories",
              constantKey: "PAYMENT_CATEGORIES",
              defaultName: "",
              label: "Payment Category",
            },
            {
              filterKey: "category",
              constantKey: "PAYMENT_CATEGORY_SUPPLIER",
              defaultName: "",
              label: "Payment Category",
            },
            {
              filterKey: "payment_type",
              constantKey: "PAYMENT_TYPE",
              defaultName: "",
              label: "Payment Type",
            },
            {
              filterKey: "payment_sub_type",
              constantKey: "PAYMENT_SUBTYPE",
              defaultName: "",
              label: "Payment SubType",
            },
            !["payment_logs_history", "vehicle_listing"].includes(moduleSearchFilter)
              ? {
                  filterKey: "status",
                  constantKey: "PAYMENT_STATUS",
                  defaultName: "",
                  label: "Payment",
                }
              : {},

            {
              filterKey: "schedule_status",
              constantKey: "SCHEDULE_STATUS",
              defaultName: "",
              label: "Schedule Status",
            },
            {
              filterKey: "out_of_state",
              constantKey: "IN_OUT_STATE",
              defaultName: "",
              label: "State",
            },
            {
              filterKey: "sale_type",
              constantKey: "SALE_TYPE_FILTER",
              defaultName: "",
              label: "Sale Type",
            },
            {
              filterKey: "po_status",
              constantKey: "PO_REPORT_STATUS",
              defaultName: "",
              label: "PO Status",
            },
            {
              filterKey: "customer_balance_type",
              constantKey: "CUSTOMER_BALANCE_TYPE",
              defaultName: "",
              label: "Customer Balance Type",
            },
            {
              filterKey: "supplier_balance_type",
              constantKey: "SUPPLIEROPTIONS",
              defaultName: "",
              label: "Supplier Balance Type",
            },
            {
              filterKey: "category_status",
              constantKey: "PAYMENT_CATEGORY",
              defaultName: "",
              label: "Payment Category",
            },
            ![filterConstants.PAYMENT_RECEIVE, filterConstants.PAYMENT_LOG, "vehicle_listing"].includes(moduleSearchFilter)
              ? {
                  filterKey: "payment_status",
                  constantKey: "PAYMENT_STATUS",
                  defaultName: "",
                  label: "Payment",
                }
              : {},
            {
              filterKey: "payment_statuses",
              constantKey: "PAYMENT_STATUSES",
              defaultName: "",
              label: "Payment Status",
            },
            {
              filterKey: "overdue_period",
              constantKey: isDashboardAgingFilter ? "AGING_OVER_DUE_PERIOD" : "OVER_DUE_PERIOD",
              defaultName: "",
              label: "Overdue Period",
            },
            {
              filterKey: "exported_pick_list",
              constantKey: "EXPORT_PICKUP_LIST",
              defaultName: "",
              label: "Export Pickup List",
            },

            // vehicle listing filters
            {
              filterKey: "status",
              constantKey: "VehicleStatus",
              defaultName: "",
              label: "Status",
            },
            {
              filterKey: "vehicle_type",
              constantKey: "VehicleType",
              defaultName: "",
              label: "Vehicle Type",
            },
            {
              filterKey: "fuel_type",
              constantKey: "FuelType",
              defaultName: "",
              label: "Fuel Type",
            },
            {
              filterKey: "cargo_capacity",
              constantKey: "VehicleLoadCapacity",
              defaultName: "",
              label: "Cargo Capacity",
            },
            {
              filterKey: "route_status",
              constantKey: "ROUTE_STATUS",
              defaultName: "",
              label: "Status",
            },
            {
              filterKey: "date_criteria",
              constantKey: "DATE_CRITERIA",
              defaultName: "",
              label: "Date Criteria",
            },
            {
              filterKey: "delivery_fulfilment_statuses",
              constantKey: "DELIVERY_FULFILMENT_STATUS",
              defaultName: "",
              label: "Fulfillment Status",
            },
            {
              filterKey: "is_archieved",
              constantKey: "SHOW_DELIVERIES",
              defaultName: "",
              label: "Deliveries",
            },
            ![filterConstants.PAYMENT_RECEIVE, filterConstants.PAYMENT_LOG].includes(moduleSearchFilter)
              ? {
                  filterKey: "payment_status",
                  constantKey: "PAYMENT_STATUS",
                  defaultName: "",
                  label: "Payment",
                }
              : {},
          ].map(({ filterKey, constantKey, defaultName, label }) => {
            const value = localSearchFilter?.advance_filters?.[filterKey];

            // Handle both single values and arrays
            const values = Array.isArray(value) ? value : [value];
            const filterNames = values
              .filter((v) => v !== null && v !== undefined)
              .map((v) => {
                if (
                  filterKey === "payment_status" &&
                  (moduleSearchFilter === filterConstants.PAYMENT_RECEIVE || moduleSearchFilter === filterConstants.PAYMENT_LOG)
                ) {
                  return Custom_Status_Name[v] || FILTERS_CONSTANTS[constantKey]?.find((filter) => filter.value == v)?.name;
                }
                return FILTERS_CONSTANTS[constantKey]?.find((filter) => filter.value == v)?.name;
              })
              .filter((name) => name); // Remove undefined/empty names
            // Check if value is truthy and filterName is not empty
            return filterNames.length > 0 ? (
              <div key={filterKey} className="filter-applied">
                <div className="filter-applied-heading">{label}:</div>
                {filterNames.join(", ")}
              </div>
            ) : null;
          })}
        </div>
      )}
    </Spin>
  );
};

export default ShowSelectedAdvanceFilter;
